import { getMaxFeedbackImageBytes } from '../feedbackImageLimits';

/**
 * `react-drag-drop-files` passes a single {@link File}, a {@link FileList} when
 * `multiple` is enabled, or an array of files depending on version/config.
 */
export function normalizeSelectedFiles(
  selected: File | FileList | File[] | null | undefined
): File[] {
  if (selected == null) return [];
  if (selected instanceof File) return [selected];
  if (selected instanceof FileList) return Array.from(selected);
  return [...selected];
}

export function isFeedbackImageWithinMaxBytes(file: File): boolean {
  return file.size <= getMaxFeedbackImageBytes();
}
